<template>
  <component :is="contractComponent" :state="state" />
</template>

<script>
import { userProjectMixin } from "../mixins/userProject.js";
export default {
  name: "ProjectViewContact",
  mixins: [userProjectMixin],
  computed: {
    contractComponent() {
      return this.contractSigned
        ? "SignedContract"
        : this.hasContract
        ? "ShowContract"
        : "NoContract";
    }
  }
};
</script>
